import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../shared/guards/auth.guards';
import { PendingChangesGuard } from '../../shared/guards/pending-changes.guard';
import { Groups } from '../security/model/groups.model';
import { BulkAddAssetsComponent } from './components/assets/bulk-add-assets.component';
import { ProductWarrantyComponent } from './components/product-warranty/product-warranty.component';
import { BulkAddProductsComponent } from './components/products/bulk-add-products.component';

export class BulkAddRoutingStates {
  public static readonly BULK_UPLOAD = {
    url: 'bulkadd'
  };
  public static readonly ASSETS = {
    url: `${BulkAddRoutingStates.BULK_UPLOAD.url}/assets`
  };
  public static readonly WARRANTY_BULK_UPLOAD = {
    url: `${BulkAddRoutingStates.BULK_UPLOAD.url}/warranty`
  };
}

export const BulkAddRoutes: Routes = [
  {
    path: BulkAddRoutingStates.BULK_UPLOAD.url,
    data: {
      page: {
        title: 'Bulk Add Assets'
      },
      requiresRole: [Groups.ASSET_ADMINISTRATOR]
    },
    component: BulkAddProductsComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard]
  },
  {
    path: BulkAddRoutingStates.ASSETS.url,
    data: {
      page: {
        title: 'Bulk Add Assets'
      },
      requiresRole: [Groups.ASSET_ADMINISTRATOR]
    },
    component: BulkAddAssetsComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard]
  },
  {
    path: BulkAddRoutingStates.WARRANTY_BULK_UPLOAD.url,
    data: {
      page: {
        title: 'Bulk Add Assets'
      },
      requiresRole: [Groups.ASSET_ADMINISTRATOR]
    },
    component: ProductWarrantyComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(BulkAddRoutes)],
  providers: [PendingChangesGuard]
})
export class BulkAddRoutingModule {}
